$(document).ready(function () {

    window.addEventListener('scroll', onScroll);
    var prevScrollpos = window.pageYOffset;

    function onScroll() {
        var currentScrollPos = window.pageYOffset;
        const header = document.getElementById('top-header');
        if(header){
          header.classList.remove('navbar--hidden');
          if (prevScrollpos < currentScrollPos) {
              header.classList.add('navbar--hidden');
          }
        }
        prevScrollpos = currentScrollPos;
    }

    // Hamburger menu
    var hamburger = document.querySelector(".hamburger");
    if(hamburger){
      hamburger.addEventListener("click", function () {
        $('body').toggleClass('overflow-hidden');
        hamburger.classList.toggle("is-active");
      });
    }

    // Hover show text
    if ($('.module-text-overlay').length) {
        $('.module-text-overlay .list-items li').click(function (){
            const parent = $(this).parents('.module-text-overlay');
            const listIndex = $(this).data('index');
            const texts = $(parent).find('.overlay-text');
            if($(this).hasClass('hover')){
                $(parent).find('.list-items li').removeClass('hover');
                $(parent).find('.card-img-overlay').removeClass('d-flex');
                $(this).next().find('.mobile-block').slideToggle();
            } else {
                $(parent).find('.list-items li').removeClass('hover');
                $(parent).find('.card-img-overlay').removeClass('d-flex');
                $(parent).find('.image').hide();
                $(this).addClass('hover');
                $(parent).find('.mobile-block').slideUp();
                $(this).next().find('.mobile-block').slideDown();
                $(texts[listIndex]).find('.card-img-overlay').addClass('d-flex');
                $(texts[listIndex]).find('.image').show();
            }
        });
    }

    // Swiper.js
    new Swiper('.swiper-companies', {
        // Optional parameters
        slidesPerView: 3,
        loop: true,
        autoplay: {
            delay: 3000,
        },
        spaceBetween: 10,

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
        },

        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 40,
            },
            1024: {
                slidesPerView: 5,
                spaceBetween: 50,
                autoplay: {
                    delay: 3000,
                },
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

    });

    new Swiper('.swiper-leaders', {
        // Optional parameters
        slidesPerView: 1,
        loop: true,
        autoplay: true,
        spaceBetween: 10,

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    const show = $('.dropdown-toggle').attr('aria-expanded');
    $("#top-header .dropdown").on("hide.bs.dropdown", function(e) {
        $('body').removeClass('body-overlay');
    })
    $("#top-header .dropdown").on("show.bs.dropdown", function(e) {
        $('body').addClass('body-overlay');
    })
    $('.language').change(function (e){
        const lang = $(this).val();
        const _token = $('meta[name=_token]').attr('content');
       $.post('/switch-language',{ lang, _token}).then( response => {
           window.location.reload();
       })
    });
    $('.footer-link .submenu').click(function (){
        $($(this).parents()[2]).find('ul').slideToggle();
    });
    if($('.drawer-el').length){
        $('.drawer-el').click(function () {
            const index = $(this).data('index');
            $.ajax({
                url: '/api/v1/leadership/leaders/' + index,
                type: 'GET',
                datatype: 'JSON',
                success: function (response) {
                    $('.drawer h2').html(response.name)
                    $('.drawer .position').html(response.position)
                    $('.drawer .description').html(response.description)
                    $('.drawer').addClass('active')
                    $('body').toggleClass('author-overlay');
                },
                error: function (error){
                    console.log(error);
                }
            })
        })
        $('.drawer-close').click(function () {
            $('.drawer').removeClass('active')
            $('body').toggleClass('author-overlay');
        })
        $(document).click(function() {
            var container = $(".drawer");
            if (!container.is(event.target) && !container.has(event.target).length) {
                $('body').removeClass('body-overlay');
                container.removeClass('active');
            }
        });
    } // Drawer end

    $(document).click(function() {
        var container = $(".dropdown-menu");
        if (!container.is(event.target) && !container.has(event.target).length) {
            $('body').removeClass('body-overlay');
            container.removeClass('active');
        }
    });

    $('.module-grid .column').hover(function (){
        const index = $(this).data('index');
        let bg = $(this).parents('.module-grid').attr('data-bg1');
        if(index == 1){
            bg = $(this).parents('.module-grid').data('bg2');
        }
        $(this).parents('.module-grid').css('background-image', "url(" + bg +")");

    });

    $('.open-search').click(function (){
        $('#search-bar').toggleClass('active');
        $('body').toggleClass('b-overlay');
    });
});

